import axios from 'axios';
import { getApiUrl } from '../../../settings';
import { getAccessToken } from '../../authApi';

export const getSmartBanners = async () => {
  const bearerToken = getAccessToken();
  const apiUrl = await getApiUrl();

  const response = await axios.request({
    method: 'GET',
    url: `${apiUrl}/api/v1/system/smartbanners`,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
  });

  return response;
};

export default getSmartBanners;
